/* Herbally enhance layer. Additive only: every feature is isolated so a failure can never affect ordering. */
(function () {
  'use strict';
  if (window.__hbxEnhance) { return; }
  window.__hbxEnhance = true;

  var WA = '923052986602';
  var TEL = '+923052986602';
  var TEL_LABEL = '0305-2986602';
  var UR = 'Noto Nastaliq Urdu,Jameel Noori Nastaleeq,Arial,sans-serif';
  var SAVE_RE = /You save PKR *[0-9][0-9,]*/i;
  var PHONE_D = 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z';
  /* Customer video reviews to show FIRST in the carousel (YouTube Shorts ids). Add new ids to the top of this list. */
  var EXTRA_VIDEOS = ['bfZ9Ppshy30'];

  function guard(fn) { try { fn(); } catch (e) { /* never break the page */ } }
  function ready(fn) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text) { n.appendChild(document.createTextNode(text)); }
    return n;
  }
  function ur(text) { var s = el('span', '', text); s.setAttribute('dir', 'rtl'); return s; }
  function phoneIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    var p = document.createElementNS(ns, 'path');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', '#fff');
    svg.setAttribute('aria-hidden', 'true');
    p.setAttribute('d', PHONE_D);
    svg.appendChild(p);
    return svg;
  }
  /* Two-line label used inside the WhatsApp / Call buttons. */
  function btnText(title, sub, isUrdu) {
    var t = el('span', 'hbx-btn__t');
    t.appendChild(el('strong', '', title));
    if (sub) {
      var s = el('small', '', sub);
      if (isUrdu) { s.setAttribute('dir', 'rtl'); s.className = 'hbx-ur'; }
      t.appendChild(s);
    }
    return t;
  }
  function track(name) { try { if (window.fbq) { window.fbq('track', name); } } catch (e) { /* ignore */ } }
  function waHref(qty) {
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent('Assalam o Alaikum, mujhe Sugar Care ke ' + qty + ' pack order karne hain.');
  }
  function fmt(n) {
    var s = String(n), o = '', c = 0, i;
    for (i = s.length - 1; i >= 0; i--) {
      o = s.charAt(i) + o;
      c += 1;
      if (c % 3 === 0 && i > 0) { o = ',' + o; }
    }
    return o;
  }

  function addStyle() {
    var css = ''
      + '.hbx-next{display:flex;gap:8px;align-items:flex-start;margin:8px 0 4px;padding:9px 12px;background:#f7fbf3;border:1px dashed #8fbf7a;border-radius:12px;font-size:12px;line-height:1.5;color:#134a09;font-weight:600}'
      + '.hbx-next__ic{flex:0 0 auto;font-size:14px;line-height:1.3}'
      + '.hbx-next em{display:block;font-style:normal;direction:rtl;font-family:' + UR + ';font-size:12.5px;line-height:1.8;color:#3d5a3a;margin-top:2px;font-weight:500}'
      + '.hbx-cta{display:flex !important;flex-wrap:wrap;gap:10px;margin:12px 0 18px !important;text-align:left !important}'
      + '.hbx-btn,.hbx-btn:visited{flex:1 1 150px;min-width:0;box-sizing:border-box;display:flex !important;align-items:center;justify-content:center;gap:9px;padding:11px 12px;min-height:54px;border:0 !important;border-radius:14px !important;color:#fff !important;text-decoration:none !important;text-align:left;-webkit-tap-highlight-color:transparent;transition:transform .12s ease}'
      + '.hbx-btn:active{transform:scale(.97)}'
      + '.hbx-btn svg{flex:0 0 22px;width:22px !important;height:22px !important;fill:#fff !important}'
      + '.hbx-btn__t{display:flex;flex-direction:column;line-height:1.3;min-width:0}'
      + '.hbx-btn__t strong{font-size:13px;font-weight:800;color:#fff}'
      + '.hbx-btn__t small{font-size:11.5px;font-weight:600;color:rgba(255,255,255,.92)}'
      + '.hbx-btn__t small.hbx-ur{direction:rtl;text-align:left;font-family:' + UR + ';font-size:12px;line-height:1.7}'
      + '.hbx-btn--wa{background:linear-gradient(135deg,#2bd46e,#128c4a) !important;box-shadow:0 8px 18px rgba(18,140,74,.28)}'
      + '.hbx-btn--call{background:linear-gradient(135deg,#1e3a5f,#12263f) !important;box-shadow:0 8px 18px rgba(18,38,63,.28)}'
      + '.hbx-paused,.hbx-paused::before,.hbx-paused::after{animation-play-state:paused !important}'
      + '.hbx-bb{position:fixed;left:10px;right:10px;bottom:calc(84px + env(safe-area-inset-bottom));z-index:99995;max-width:460px;margin:0 auto;padding:14px 14px 12px;background:#fff;border:1.5px solid #25d366;border-radius:16px;box-shadow:0 14px 34px rgba(0,0,0,.28);font-size:13px;color:#12263f}'
      + '.hbx-bb__x{position:absolute;top:4px;right:8px;width:30px;height:30px;border:0;background:transparent;font-size:22px;line-height:1;color:#666;cursor:pointer}'
      + '.hbx-bb__t{font-weight:800;font-size:14px;padding-right:26px}'
      + '.hbx-bb__t span,.hbx-bb__s span{display:block;direction:rtl;font-family:' + UR + ';font-weight:600;font-size:12.5px;color:#3d5a3a}'
      + '.hbx-bb__s{margin:4px 0 10px;line-height:1.5;color:#3a3a3a}'
      + '.hbx-bb__row{display:flex;gap:8px}'
      + '.hbx-bb__row .hbx-btn{flex:1 1 0;min-height:46px;padding:8px 10px}'
      + '.hb-fbuy,[class^=ai-whatsapp-widget-]{transition:opacity .2s ease}'
      + 'body.hbx-floats-off .hb-fbuy,body.hbx-floats-off [class^=ai-whatsapp-widget-]{opacity:0 !important;pointer-events:none !important}'
      + '@media(min-width:750px){.hbx-bb{left:auto;right:24px;bottom:130px;margin:0;width:420px}}';
    var s = document.createElement('style');
    s.setAttribute('data-hbx', '1');
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }

  /* 1. Tell the customer what the next (checkout) page asks for. */
  function journeyLine() {
    var qb = document.querySelector('quantity-breaks');
    if (!qb || !qb.parentNode || document.querySelector('.hbx-next')) { return; }
    var d = el('div', 'hbx-next');
    d.appendChild(el('span', 'hbx-next__ic', '✅'));
    var b = el('span');
    b.appendChild(el('strong', '', 'Order Now'));
    b.appendChild(document.createTextNode(' dabane par agla page: sirf naam, phone aur address. Payment delivery par (COD).'));
    var u = el('em', '', 'اگلے صفحے پر صرف نام، فون نمبر اور پتہ۔ ادائیگی ڈیلیوری پر (COD)۔');
    u.setAttribute('dir', 'rtl');
    b.appendChild(u);
    d.appendChild(b);
    qb.parentNode.insertBefore(d, qb.nextSibling);
  }

  /* 2. WhatsApp + Call as two proper buttons (Meta Contact event on both). The WhatsApp link element is kept, so the page keeps updating its pack text. */
  function contactButtons() {
    var wa = document.getElementById('hbWaBtn');
    if (!wa || !wa.parentNode || document.querySelector('.hbx-cta')) { return; }
    var box = wa.parentNode;
    var icon = wa.querySelector('svg');
    box.removeAttribute('style');
    box.className = 'hbx-cta';
    while (wa.firstChild) { wa.removeChild(wa.firstChild); }
    wa.removeAttribute('style');
    wa.className = 'hbx-btn hbx-btn--wa';
    if (icon) {
      icon.removeAttribute('width');
      icon.removeAttribute('height');
      icon.setAttribute('fill', '#fff');
      wa.appendChild(icon);
    }
    wa.appendChild(btnText('WhatsApp', 'واٹس ایپ پر آرڈر', true));
    var call = el('a', 'hbx-btn hbx-btn--call');
    call.href = 'tel:' + TEL;
    call.appendChild(phoneIcon());
    call.appendChild(btnText('Call karein', TEL_LABEL, false));
    call.addEventListener('click', function () { track('Contact'); });
    wa.addEventListener('click', function () { track('Contact'); });
    box.appendChild(call);
  }

  /* 3. Homepage pack cards open the product page with that pack already selected. */
  function homePacks() {
    var cards = document.querySelectorAll('.hb-bundle-grid .hb-card'), i, a, h;
    for (i = 0; i < cards.length; i++) {
      a = cards[i].querySelector('a.hb-btn');
      h = a ? a.getAttribute('href') : '';
      if (h && h.indexOf('pack=') === -1 && h.indexOf('?') === -1) { a.setAttribute('href', h + '?pack=' + (i + 1)); }
    }
  }
  function preselectPack() {
    var m = /[?&]pack=([1-4])/.exec(location.search);
    if (!m) { return; }
    var want = m[1], tries = 0;
    (function attempt() {
      var inputs = document.querySelectorAll('quantity-breaks input[name=quantity]'), target = null, i;
      for (i = 0; i < inputs.length; i++) { if (String(inputs[i].value) === want) { target = inputs[i]; } }
      if (target) { if (!target.checked) { target.click(); } return; }
      tries += 1;
      if (tries < 12) { setTimeout(attempt, 250); }
    })();
  }

  /* 4. Bundle caption savings must agree with the prices shown (computed from the two amounts on screen). */
  function amounts(str) {
    var out = [], re = /(?:Rs[.]?|PKR)[ ]*([0-9][0-9,]*)/gi, m, v;
    while ((m = re.exec(str)) !== null) {
      v = parseInt(m[1].split(',').join(''), 10);
      if (v > 0 && out.indexOf(v) === -1) { out.push(v); }
    }
    return out;
  }
  function fixCaptions() {
    var qb = document.querySelector('quantity-breaks');
    if (!qb) { return; }
    var w = document.createTreeWalker(qb, NodeFilter.SHOW_TEXT, null, false), nodes = [], n;
    while ((n = w.nextNode())) { if (SAVE_RE.test(n.nodeValue)) { nodes.push(n); } }
    nodes.forEach(function (node) {
      var box = node.parentNode, hops = 0, vals = [], save, next;
      while (box && box !== qb && hops < 6) {
        vals = amounts(box.textContent.replace(new RegExp(SAVE_RE.source, 'ig'), ''));
        if (vals.length >= 2) { break; }
        box = box.parentNode;
        hops += 1;
      }
      if (vals.length !== 2) { return; }
      save = Math.abs(vals[0] - vals[1]);
      if (!save) { return; }
      next = node.nodeValue.replace(SAVE_RE, 'You save PKR ' + fmt(save));
      if (next !== node.nodeValue) { node.nodeValue = next; }
    });
  }
  function watchCaptions() {
    var qb = document.querySelector('quantity-breaks');
    if (!qb || !window.MutationObserver) { return; }
    var timer = null, runs = 0;
    new MutationObserver(function () {
      if (timer || runs > 30) { return; }
      timer = setTimeout(function () { timer = null; runs += 1; guard(fixCaptions); }, 200);
    }).observe(qb, { subtree: true, childList: true, characterData: true });
  }

  /* 5. Decorative shine/pulse animations only run while on screen (same look, less CPU on cheap phones). */
  function pauseOffscreen() {
    if (!('IntersectionObserver' in window)) { return; }
    var els = document.querySelectorAll('.sc-ing-card,.sctr-badge,.sc-badge,.sc-trust-card,.limited-stock-box,.in-stock-box,.out-stock-box'), i;
    if (!els.length) { return; }
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (x) { x.target.classList.toggle('hbx-paused', !x.isIntersecting); });
    }, { rootMargin: '120px' });
    for (i = 0; i < els.length; i++) { io.observe(els[i]); }
  }

  /* 6. Customer pressed Back from checkout: offer a human way to finish the order (WhatsApp / call). */
  function showBounce() {
    if (document.getElementById('hbxBounce') || !document.querySelector('quantity-breaks')) { return; }
    var raw = null, qty;
    try { raw = JSON.parse(sessionStorage.getItem('hbCkStart') || 'null'); } catch (e) { raw = null; }
    if (!raw || !raw.t || Date.now() - raw.t > 2700000) { return; }
    try {
      if (sessionStorage.getItem('hbxBounceShown')) { return; }
      sessionStorage.setItem('hbxBounceShown', '1');
    } catch (e2) { return; }
    qty = raw.q > 0 ? raw.q : 1;
    var box = el('div', 'hbx-bb');
    box.id = 'hbxBounce';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', 'Order help');
    var x = el('button', 'hbx-bb__x', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', function () { if (box.parentNode) { box.parentNode.removeChild(box); } });
    var t = el('div', 'hbx-bb__t', 'Order mein madad chahiye?');
    t.appendChild(ur('آرڈر میں مدد چاہیے؟'));
    var s = el('div', 'hbx-bb__s', 'WhatsApp par bata dein, hum aap ka order lagwa denge. Payment delivery par.');
    var row = el('div', 'hbx-bb__row');
    var wa = el('a', 'hbx-btn hbx-btn--wa');
    wa.href = waHref(qty);
    wa.target = '_blank';
    wa.rel = 'noopener';
    var waIcon = document.querySelector('#hbWaBtn svg');
    if (waIcon) { wa.appendChild(waIcon.cloneNode(true)); }
    wa.appendChild(btnText('WhatsApp', '', false));
    var call = el('a', 'hbx-btn hbx-btn--call');
    call.href = 'tel:' + TEL;
    call.appendChild(phoneIcon());
    call.appendChild(btnText('Call karein', '', false));
    wa.addEventListener('click', function () { track('Contact'); });
    call.addEventListener('click', function () { track('Contact'); });
    row.appendChild(wa);
    row.appendChild(call);
    box.appendChild(x);
    box.appendChild(t);
    box.appendChild(s);
    box.appendChild(row);
    document.body.appendChild(box);
  }
  function bounceInit() {
    if (!document.querySelector('quantity-breaks')) { return; }
    var nav = null;
    try { nav = performance.getEntriesByType('navigation')[0]; } catch (e) { nav = null; }
    if (nav && nav.type === 'back_forward') { setTimeout(function () { guard(showBounce); }, 900); }
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) { setTimeout(function () { guard(showBounce); }, 900); }
    });
  }

  /* 8. The floating Buy Now / WhatsApp pills sit on the right edge and hide the bundle prices on small phones. While the bundle selector or the contact buttons are on screen, the pills fade out (the sticky Order Now bar always stays). */
  function floatGuard() {
    if (!('IntersectionObserver' in window)) { return; }
    var targets = document.querySelectorAll('quantity-breaks,.hbx-cta'), i, seen = [];
    if (!targets.length) { return; }
    var io = new IntersectionObserver(function (list) {
      var k, any = false;
      list.forEach(function (x) {
        for (k = 0; k < targets.length; k++) { if (targets[k] === x.target) { seen[k] = x.isIntersecting; } }
      });
      for (k = 0; k < targets.length; k++) { if (seen[k]) { any = true; } }
      document.body.classList.toggle('hbx-floats-off', any);
    }, { threshold: 0 });
    for (i = 0; i < targets.length; i++) { seen[i] = false; io.observe(targets[i]); }
  }

  /* 7. Put the newest customer video review(s) first in the video carousel (same markup + click handling as the others). */
  function extraVideos() {
    var row = document.getElementById('hbytRow');
    if (!row) { return; }
    var i, j, id, have, kids, item, frame, a, img, btn;
    for (i = EXTRA_VIDEOS.length - 1; i >= 0; i--) {
      id = EXTRA_VIDEOS[i];
      have = false;
      kids = row.children;
      for (j = 0; j < kids.length; j++) { if (kids[j].getAttribute('data-id') === id) { have = true; } }
      if (have) { continue; }
      item = el('div', 'hbyt__item');
      item.setAttribute('data-id', id);
      frame = el('div', 'hbyt__frame');
      a = el('a', 'hbyt__play');
      a.href = 'https://www.youtube.com/shorts/' + id;
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', 'Play customer video review');
      img = el('img', 'hbyt__thumb');
      img.setAttribute('data-id', id);
      img.alt = '';
      img.setAttribute('loading', 'lazy');
      (function (im, vid) {
        function fb() {
          if (im.getAttribute('data-fb')) { im.style.display = 'none'; return; }
          im.setAttribute('data-fb', '1');
          im.src = 'https://i.ytimg.com/vi/' + vid + '/hqdefault.jpg';
        }
        im.addEventListener('load', function () { if (!im.getAttribute('data-fb') && im.naturalWidth <= 120) { fb(); } });
        im.addEventListener('error', fb);
      })(img, id);
      img.src = 'https://i.ytimg.com/vi/' + id + '/maxres2.jpg';
      btn = el('span', 'hbyt__btn');
      a.appendChild(img);
      a.appendChild(btn);
      frame.appendChild(a);
      item.appendChild(frame);
      row.insertBefore(item, row.firstChild);
    }
  }

  ready(function () {
    guard(addStyle);
    guard(journeyLine);
    guard(contactButtons);
    guard(extraVideos);
    guard(floatGuard);
    guard(homePacks);
    guard(preselectPack);
    guard(fixCaptions);
    guard(watchCaptions);
    guard(pauseOffscreen);
    guard(bounceInit);
  });
})();
